export const PAYTM_CITY_SEARCH_DATA = 'paytm-city-search-data'
